module.exports = __webpack_public_path__ + "img/life@Q_fun.6dfc8efd.jpg";